<template>
    <div class="data_container">
        <div class="data_head">{{title}}</div>
        <div class="data_data">{{data}}
            <span class="data_unit">{{unit}}</span>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "dataitemC",
        props: ['title', 'data', 'unit']
    }
</script>

<style lang="less" scoped>
    .data_container {
        .w(280);
        .h(153);
        background: rgba(0, 43, 102, 0.04);
        padding: 0 24rem;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;

        .data_head {
            font-size: 18rem;
            font-weight: bold;
            color: #666;
        }

        .data_data {
            font-size: 30rem;
            font-weight: bold;
            color: #0D94FF;
        }
    }
</style>